export default __webpack_public_path__ + "static/linux-icon-c966b4faf75655c3cf1a2e8998bf6c06.png";